import React from 'react';
import "../../styles/ConversionCTA.css"; 

export default function ConversionCTA() {
  return (
    <section className="about-client-conversion-cta-banner-wrapper">
      <div className="primary-blue-cta-card-shell">
        
        
        <div className="cta-card-bg-mesh"></div>

        
        <div className="cta-graphic-side-node left-mortarboard">
          <span className="graphic-emoji-asset">🎓</span>
          <div className="mini-play-badge-accent">▶</div>
        </div>

        
        <div className="cta-central-messaging-core">
          <h2>Ready To Start Your Creator Journey?</h2>
          <p>Join 50,000+ creators who are learning, growing and winning together.</p>
          
          <div className="cta-action-buttons-group-row">
            <button className="cta-yellow-solid-btn">
              Start Learning Now <span className="arrow-vector">➔</span>
            </button>
            
          </div>
        </div>

       
        <div className="cta-graphic-side-node right-trophy">
          <span className="graphic-emoji-asset">🏆</span>
          <div className="gold-sparks-particles"></div>
        </div>

      </div>
    </section>
  );
}